var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "disc-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 4.43648V9.99997C12.2497 10.4775 12.0975 10.9426 11.8154 11.328C11.5333 11.7133 11.1359 11.9989 10.6807 12.1434C10.2255 12.2878 9.73615 12.2837 9.28344 12.1316C8.83074 11.9796 8.43817 11.6874 8.16254 11.2974C7.88692 10.9073 7.74254 10.4398 7.7503 9.96225C7.75806 9.48474 7.91755 9.02208 8.2057 8.64124C8.49384 8.26039 8.8957 7.9811 9.3531 7.8438C9.81051 7.70649 10.2997 7.71829 10.75 7.87748V2.53748C14.5398 2.91323 17.5 6.11123 17.5 9.99997C17.5 14.1422 14.1423 17.5 10 17.5C5.85775 17.5 2.5 14.1422 2.5 9.99997C2.5 6.11123 5.46025 2.91323 9.25 2.53748V4.04648C7.73703 4.23899 6.35414 5.00038 5.38239 6.17589C4.41064 7.3514 3.92296 8.85282 4.01847 10.375C4.11397 11.8972 4.7855 13.3259 5.89656 14.3707C7.00762 15.4155 8.47484 15.9981 10 16C11.393 16.0008 12.7429 15.5168 13.8181 14.6312C14.8933 13.7455 15.6268 12.5133 15.8929 11.146C16.1589 9.77859 15.9409 8.36126 15.2763 7.13706C14.6116 5.91286 13.5417 4.95808 12.25 4.43648Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.ef9e7f138d73053e9f82b16c7af7374d.svg";
export { ForwardRef as ReactComponent };